import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Overlay from '../../../forms/_common/Overlay';
import FormErrors from '../../../forms/_common/FormErrors';
import RequestError from '../../../forms/_common/RequestError';
import ErrorMessage from '../../../forms/_common/ErrorMessage';
import FormField from '../../../forms/_common/FormField';
import FormTemplate from '../../_post-opportunity/FlowTemplate';
// import CheckboxField from '../../_post-opportunity/_fields/CheckboxField';
import CheckboxField from '../../../forms/_fields_v2/CheckboxField';
import { BuildingOfficeIcon, GlobeAltIcon } from '@heroicons/react/24/outline';
import { useQueryMutation } from '../../../../hooks/@lore/query-connect';
import useIntents from '../../../hooks/useIntents';

Form.propTypes = {
  user: PropTypes.object.isRequired
};

export default function Form(props) {
  const {
    user,
    navigation,
    onNext,
    onPrevious,
    onSkip,
    onExit,
    buttonText = 'Next'
  } = props;

  const { isEducator } = useIntents(user);

  const [data, setData] = useState(_.pick(user.data, [
    'virtual',
    'inPerson'
  ]));
  const [showErrors, setShowErrors] = useState(false);
  const [exit, setExit] = useState(false);

  const mutation = useQueryMutation('currentUser.updateSingleton', user);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      exit ? onExit(data) : onNext(data);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onSubmitAndExit() {
    onSubmit();
    setExit(true);
  }

  function onChange(name, value) {
    setData(_.merge({}, data, {
      [name]: value
    }));
  }

  return (
    <Overlay isVisible={saving}>
      <FormErrors data={data} validators={{
        // field: [validators.isRequired]
      }}>
        {({ errors, hasError }) => {
          return (
            <FormTemplate
              onExit={() => hasError ? setShowErrors(true) : onSubmitAndExit()}
              alert={error ? (
                <RequestError request={request} />
              ) : showErrors ? (
                <ErrorMessage>
                  Please fill in all required fields.
                </ErrorMessage>
              ) : null}
              body={(
                <div className="row">
                  <div className="col-md-12 space-y-8">
                    <FormField name="virtual" data={data} errors={showErrors && errors} onChange={onChange}>
                      {(field) => (
                        <CheckboxField
                          label={(
                            <div className="flex items-center space-x-1">
                              <GlobeAltIcon className="h-5 w-5" />
                              <span>
                                Virtual
                              </span>
                            </div>
                          )}
                          description={(
                            <>
                              Connect with collaborators within your local community as well as
                              other communities across the nation. You'll have a wider range of
                              opportunities. Virtual also tends to be lower effort.
                            </>
                          )}
                          checked={field.value}
                          error={field.error}
                          onChange={(event) => field.onChange(event.target.checked)}
                        />
                      )}
                    </FormField>
                    <FormField name="inPerson" data={data} errors={showErrors && errors} onChange={onChange}>
                      {(field) => (
                        <CheckboxField
                          label={(
                            <div className="flex items-center space-x-1">
                              <BuildingOfficeIcon className="h-5 w-5" />
                              <span>
                                In-person
                              </span>
                            </div>
                          )}
                          description={(
                            <>
                              Connect with collaborators in your local community. These can require
                              a little more effort but tend to have a greater impact on students.
                            </>
                          )}
                          checked={field.value}
                          error={field.error}
                          onChange={(event) => field.onChange(event.target.checked)}
                        />
                      )}
                    </FormField>
                  </div>
                </div>
              )}
              // footer={(
              //   <>
              //     <PrimaryButton onClick={() => hasError ? setShowErrors(true) : onSubmit()}>
              //       {buttonText}
              //     </PrimaryButton>
              //   </>
              // )}
            />
          );
        }}
      </FormErrors>
    </Overlay>
  );
};
